import { captureException } from '@sentry/gatsby';

const errorLogger = (
  error: Error | AnyType,
  hint?: Parameters<typeof captureException>[1]
): void => {
  if (process.env.NODE_ENV === 'development') {
    console.error(error, hint);
  } else {
    captureException(error, hint);
  }
};

export default errorLogger;
